import {ChangeDetectionStrategy, Component, input} from '@angular/core'

@Component({
  selector: 'cft-carousel-accordion',
  templateUrl: './carousel-accordion.component.html',
  styles: [
    `
      @reference '../../../styles/theme.css';

      :host {
        @apply block bg-grey-50;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselAccordionComponent {
  plot = input.required<string>()
  title = input.required<string>()
  _layout = input<'h-layout' | 'h-content-layout'>('h-content-layout', {alias: 'layout'}) //eslint-disable-line @angular-eslint/no-input-rename
}
